import React from "react";

import Typography from "@mui/material/Typography";

import type { MeetingReportErrorFeedItem } from "@app/analytics/Home/types";
import LINKS from "@app/common/links";
import ROUTES from "@app/common/routes";

import { Link } from "@rui/Link";
import { Column } from "@rui/Stack";

import DetailsPanelHeader from "./DetailsPanelHeader";
import { DetailsPanelContent, DetailsPanelFooter, Panel } from "./styles";
import { ActionButton } from "../styles";

interface MeetingReportErrorDetailsPanel {
  item: MeetingReportErrorFeedItem;
  onClose: () => void;
}

const MeetingReportErrorDetailsPanel = ({
  item,
  onClose,
}: MeetingReportErrorDetailsPanel) => {
  return (
    <Panel>
      <DetailsPanelHeader item={item} onClose={onClose} />
      <DetailsPanelContent spacing={1.5}>
        <Column spacing={0.5}>
          <Typography variant="bodySecondaryMed">Reporting error</Typography>
          <Typography variant="bodySecondaryReg">{item.text}</Typography>
        </Column>
        <Typography variant="bodySecondaryReg">
          <Link
            fontWeight={400}
            underline
            href={LINKS.SUPPORT.INCOMPLETE_REPORTS}
          >
            View our help article
          </Link>{" "}
          on incomplete meeting reports for more information.
        </Typography>
      </DetailsPanelContent>
      <DetailsPanelFooter>
        <Link to={ROUTES.meetingReportById(item.session.id)}>
          <ActionButton>View incomplete</ActionButton>
        </Link>
      </DetailsPanelFooter>
    </Panel>
  );
};

export default MeetingReportErrorDetailsPanel;
